export var inAppNotificationUri = '/in-app-notifications';
export var enableInAppNotificationsUri = "".concat(inAppNotificationUri, "/enabled");
export var createInAppNotificationsApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(inAppNotificationUri);
    var configureInAppNotificationUrl = "".concat(baseUrl).concat(enableInAppNotificationsUri);
    return {
        getInAppNotificationSettings: function () { return http.get(apiUrl); },
        configureInAppNotification: function (dto) { return http.post(configureInAppNotificationUrl, dto); },
    };
};
//# sourceMappingURL=index.js.map